import React from 'react'

import { Grid, Paper, Theme, Typography, useMediaQuery } from '@mui/material'

import Calendar from './Calendar'
import FamilyCalendarNav from './FamilyCalendarNav'
import { getAppTheme } from '../../../../shared/config/getAppTheme'

export interface CalendarDateParams {
  from: Date
  to: Date
}

const FamilyCalendar: React.FC = () => {
  const theme: Theme = getAppTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const [selectedDate, setSelectedDate] = React.useState<number>(Date.now())

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Geburtstage</Typography>
      <Grid
        container
        direction='row'
      >
        <Grid container item xs={12}>
          <FamilyCalendarNav
            selectedDate={selectedDate}
            changeSelectedDate={(date: number) => setSelectedDate(date)}
          />
        </Grid>
        <Grid container item xs={12} style={{ marginBottom: theme.spacing(8) }}>
          <Grid item xs={12} sx={{ width: '100%' }}>
            <Calendar
              selectedDate={selectedDate}
              calendarData={[]}
              changeSelectedDate={(date: number) => setSelectedDate(date)}
            />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}
export default FamilyCalendar
